import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

function formatViews(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1).replace(/\.0$/, '')}万`;
  return `${n}`;
}

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="group flex flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · ${comic.category}漫画`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-background-950/60 px-2 py-0.5 text-xs font-bold text-background-50 backdrop-blur">
          {comic.category}
        </span>
        {comic.status === '已完结' ? (
          <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
            完结
          </span>
        ) : comic.newArrival ? (
          <span className="absolute right-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
            新作
          </span>
        ) : null}
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{comic.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-600">{comic.author} · {comic.chapterCount}话</p>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1 text-accent-700">
            <i className="ri-star-fill"></i>
            {comic.rating}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatViews(comic.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}